export enum ApiStatus {
    Idle = "Idle",
    Pending = "Pending",
    Rejected = "Rejected",
    Fulfilled = "Fulfilled",
  }
  